import AppDropdownMenu from '@js/components/navigation/AppDropdownMenu.vue'
import AppSiteSearch from '@js/components/navigation/AppSiteSearch.vue'
import AppAccountDropdown from '@js/components/navigation/AppAccountDropdown.vue'
import AppMobileMenu from '@js/components/navigation/AppMobileMenu.vue'
import AppAccordionMenu from '@js/components/navigation/AppAccordionMenu.vue'

const navigationComponents = [
  AppAccordionMenu,
  AppAccountDropdown,
  AppDropdownMenu,
  AppMobileMenu,
  AppSiteSearch,
]

export default navigationComponents
